/**
 * Blinking Cursor
 * @param props to blink?
 * @returns
 */
export default function BlinkingCursor(props: { blink: boolean }) {
  return <span className={`${props.blink ? 'animate-cursor-blink' : ''} inline-block align-text-bottom w-2 h-4 bg-brand-800`}></span>
}
